/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2016, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'underscore',
	'react',
	'react-dom',
	'./topBottomDialog/TopBottomComponent'
], function (View, _, React, ReactDOM, TopBottomComponent) {


	/**
	 * @classdesc  Creates a topBottom dialog
	 *
	 * @public
	 * @callback callback
	 * @param {object} options.eventHandler - Event handler
	 * @param {object} [options.state] - If you want to pass the existing top/bottom state
	 * @param {Array} [options.contextColumns] - An array of columns to search from for attribute column, if omitted this field is not shown
	 * @param {boolean} [options.allowRankColumn] - Puts a checkbox on the dialog to add rank column on creation.
	 * @param {callback} [options.onSearch] - on search call back
	 */
	class TopBottomView extends View {

		constructor(...args) {
			super(...args);

			const options = args && args[0];
			this._state = options.state.getTopBottomState ? options.state.getTopBottomState() : null;
			this._focusReady = new Promise(resolve => this._setFocusReady = resolve);
			this._selectionHandler = options.actions.apply;
			this._contextColumns = options.state.contextColumns;
			this._allowPercentOperations = options.state.allowPercentOperations;
			this.allowRankColumn = options.state.allowRankColumn;
			this._onSearch = options.state.onSearch;

			this._iHeight = '212';
			this._iWidth = '290';
		}

		remove() {
			if (this.$el) {
				ReactDOM.unmountComponentAtNode(this.$el[0]);
			}
			this.viewState = null;
			return super.remove();
		}

		setFocus() {
			this._setFocusReady();
		}

		render() {
			this.$el
				.addClass('popoverTBDialogContainer topbottomDialog')
				.height(this._iHeight + 'px')
				.width(this._iWidth + 'px');

			//Note: TopBottomView is not a React component, so unlike all the other render()s in this file,
			//this will NOT rerender when its internal state changes. So, these properties are only initial values.
			this.reactComponents = ReactDOM.render(
				<TopBottomComponent
					state={this._state}
					onStateChange={state => this._newState(state)}
					focusReady={this._focusReady}
					measures={this._contextColumns}
					supportsPercentOperations={this._allowPercentOperations}
					supportsContext={this._isContextual()}
					supportsRank={this.allowRankColumn}
				/>,
				this.$el[0]
			);

			return this;
		}

		_newState(state) {
			this._selectionHandler(state);
		}

		_isContextual() {
			return !!this._contextColumns;
		}
	}

	return TopBottomView;
});
